module.exports = __webpack_public_path__ + "img/window.2fc90d7d.png";